
const state = {
  tabTitleList: [
    '已发起',
    '待处理',
    '已处理',
    '我收到'
  ],
  dialogTitleMap: {
    1: "查看",
    2: "修改",
    3: "新增",
  },
  MenuType: {
    'CATALOG': "目录",
    'MENU': "菜单",
    'BUTTON': "按钮",
  },
  OptionType: [
    'DETAIL',
    'UPDATE',
    'SAVE',
    'DELETE'
  ],
  WorkFlowStatus: {
    initiate: "发起",
    copy: "抄送",
    wait:"等待",
    in_approval: "审批中",
    approvaled: "通过",
    rejected: "拒绝",
    skipped: "跳过",
  },
  WorkFlowStatusFilter: {
    in_approval: "审批中",
    approvaled: "通过",
    rejected: "拒绝",
  },
  PaymentMethodList: {
    'check' : '转账',
    'cash' : '现金',
    // 'other' : '其他'
  },
  ProjectAuthType: {
    'ALL': '所有项目',
    'SPECIFY': '指定项目',
  },
  DeviceStatus: {
    'IN_STOCK': '入库',
    'IN_USE': '项目在用',
    'CONSUME': '消耗',
    'SCRAP': '报废',
  },
  DeviceOperation: {
    'STOCK': '入库',
    'DISPATCH': '调度',
    'CONSUME': '消耗',
    'SCRAP': '报废',
  },
}
const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
